import type { GroupMember } from "@kekkle/shared/types/fields/group-member/group-member";

/**
 * Format a list of UUIDs into member names from group members data
 * @param uuids Array of member UUIDs
 * @param members Group members object
 * @param deletedUserText Text to display for deleted users
 * @returns Object mapping UUID to member name
 */
export function formatMemberNamesMap(
  uuids: string[] | null | undefined,
  members: {
    [key: string]: GroupMember;
  },
  deletedUserText: string,
): Record<string, string> {
  const names: Record<string, string> = {};

  if (!uuids) {
    return names;
  }

  uuids.forEach((uuid) => {
    if (members[uuid]?.name) {
      names[uuid] = members[uuid].name;
    } else {
      names[uuid] = deletedUserText;
    }
  });

  return names;
}

/**
 * Format a list of UUIDs into a comma-separated string of member names
 * @param uuids Array of member UUIDs
 * @param members Group members object
 * @param deletedUserText Text to display for deleted users
 * @returns Comma-separated string of member names
 */
export function formatMemberNamesList(
  uuids: string[] | null | undefined,
  members: {
    [key: string]: GroupMember;
  },
  deletedUserText: string,
): string {
  if (!uuids || uuids.length === 0) {
    return "";
  }

  const names: string[] = [];

  uuids.forEach((uuid) => {
    if (members[uuid]?.name) {
      names.push(members[uuid].name);
    } else {
      names.push(deletedUserText);
    }
  });

  return names.join(", ");
}
